import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import '../../styles/global.css';

interface ActiveItem {
  item_id: number;
  assignment_id: number;
}

interface CloseActiveItemModalProps {
  activeItem: ActiveItem;
  onClose: (reason: 'niepelna_produkcja' | 'problem_bb' | 'problem_awaria' | 'pending', wykonanoIlosc?: number) => void;
  onCancel: () => void;
}

const CloseActiveItemModal: React.FC<CloseActiveItemModalProps> = ({
  activeItem,
  onClose,
  onCancel,
}) => {
  const { t } = useLanguage();
  const [selectedReason, setSelectedReason] = useState<'niepelna_produkcja' | 'problem_bb' | 'problem_awaria' | 'pending' | null>(null);
  const [wykonanoIlosc, setWykonanoIlosc] = useState<string>('');

  const handleReasonSelect = (reason: 'niepelna_produkcja' | 'problem_bb' | 'problem_awaria' | 'pending') => {
    setSelectedReason(reason);
  };

  const handleSubmit = () => {
    if (!selectedReason) return;
    
    if (selectedReason === 'niepelna_produkcja') {
      const ilosc = parseInt(wykonanoIlosc);
      if (isNaN(ilosc) || ilosc < 0) {
        alert(t('shift.mustProvideCorrectQuantity'));
        return;
      }
      onClose(selectedReason, ilosc);
    } else {
      onClose(selectedReason);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '30px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: '20px', color: '#dc3545', textAlign: 'center' }}>
          ⚠️ {t('activeItem.closeTitle')}
        </h2>
        
        <div style={{ marginBottom: '25px', textAlign: 'center', fontSize: '16px', color: '#4a5568' }}>
          <strong>{t('activeItem.selectCloseReason')}</strong>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
          <button
            onClick={() => handleReasonSelect('niepelna_produkcja')}
            style={{
              padding: '15px',
              border: selectedReason === 'niepelna_produkcja' ? '3px solid #667eea' : '2px solid #e1e8ed',
              borderRadius: '8px',
              backgroundColor: selectedReason === 'niepelna_produkcja' ? '#e7f3ff' : 'white',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '15px',
              fontWeight: selectedReason === 'niepelna_produkcja' ? '600' : '400',
            }}
          >
            📊 {t('production.status.incomplete')}
          </button>
          
          <button
            onClick={() => handleReasonSelect('problem_bb')}
            style={{
              padding: '15px',
              border: selectedReason === 'problem_bb' ? '3px solid #667eea' : '2px solid #e1e8ed',
              borderRadius: '8px',
              backgroundColor: selectedReason === 'problem_bb' ? '#e7f3ff' : 'white',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '15px',
              fontWeight: selectedReason === 'problem_bb' ? '600' : '400',
            }}
          >
            ⚠️ {t('production.status.problemBB')}
          </button>
          
          <button
            onClick={() => handleReasonSelect('problem_awaria')}
            style={{
              padding: '15px',
              border: selectedReason === 'problem_awaria' ? '3px solid #667eea' : '2px solid #e1e8ed',
              borderRadius: '8px',
              backgroundColor: selectedReason === 'problem_awaria' ? '#e7f3ff' : 'white',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '15px',
              fontWeight: selectedReason === 'problem_awaria' ? '600' : '400',
            }}
          >
            🔧 {t('production.status.problemFailure')}
          </button>
          
          <button
            onClick={() => handleReasonSelect('pending')}
            style={{
              padding: '15px',
              border: selectedReason === 'pending' ? '3px solid #667eea' : '2px solid #e1e8ed',
              borderRadius: '8px',
              backgroundColor: selectedReason === 'pending' ? '#e7f3ff' : 'white',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '15px',
              fontWeight: selectedReason === 'pending' ? '600' : '400',
            }}
          >
            ❌ {t('production.status.pending')}
          </button>
        </div>

        {selectedReason === 'niepelna_produkcja' && (
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#4a5568' }}>
              {t('activeItem.completedQuantity')}:
            </label>
            <input
              type="number"
              value={wykonanoIlosc}
              onChange={(e) => setWykonanoIlosc(e.target.value)}
              min="0"
              placeholder="0"
              className="input"
              style={{ width: '100%' }}
            />
          </div>
        )}

        <div style={{ display: 'flex', gap: '15px' }}>
          <button
            onClick={handleSubmit}
            disabled={!selectedReason || (selectedReason === 'niepelna_produkcja' && !wykonanoIlosc)}
            className="btn btn-primary"
            style={{
              flex: 1,
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              opacity: (!selectedReason || (selectedReason === 'niepelna_produkcja' && !wykonanoIlosc)) ? 0.6 : 1,
              cursor: (!selectedReason || (selectedReason === 'niepelna_produkcja' && !wykonanoIlosc)) ? 'not-allowed' : 'pointer',
            }}
          >
            ✅ {t('activeItem.close')}
          </button>
          <button
            onClick={onCancel}
            className="btn btn-outline"
            style={{
              flex: 1,
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
            }}
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseActiveItemModal;











